export default __webpack_public_path__ + "static/media/iran-Flag-icon.8bc1e4ec.png";